import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ShortcutService {
  private router = inject(Router);
  private ngZone = inject(NgZone);
  private shortcutsEnabled = true;

  constructor() {
    this.setupGlobalListeners();
  }

  enable() {
    this.shortcutsEnabled = true;
  }

  disable() {
    this.shortcutsEnabled = false;
  }

  private setupGlobalListeners() {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (!this.shortcutsEnabled) return;

      // Avoid triggering shortcuts when typing in inputs/textareas unless it's a function key
      const activeEl = document.activeElement?.tagName;
      if (activeEl === 'INPUT' || activeEl === 'TEXTAREA' || activeEl === 'SELECT') {
        if (!event.key.startsWith('F')) {
          return;
        }
      }

      switch (event.key) {
        case 'F1':
          event.preventDefault();
          this.ngZone.run(() => {
            this.router.navigate(['/app/vendas/orcamentos/novo']);
          });
          break;
        case 'F2':
          event.preventDefault();
          this.ngZone.run(() => {
            this.router.navigate(['/app/vendas/pedidos']);
          });
          break;
        case 'F3':
          event.preventDefault();
          this.ngZone.run(() => {
            this.router.navigate(['/app/vendas/pdv']);
          });
          break;
      }
    });
  }
}
